module.exports = __webpack_public_path__ + "img/3.94899687.png";